const cleanValue = (value) => `${value || ''}`.trim()

const getDocumentTypeList = (response) => {
  if (Array.isArray(response)) return response
  if (Array.isArray(response?.document_types)) {
    return response.document_types
  }
  if (Array.isArray(response?.types)) return response.types
  return []
}

export const mapDocumentTypeResponse = (response) =>
  getDocumentTypeList(response)
    .map((documentType) => {
      const displayName = cleanValue(documentType.display_name)
      const id = cleanValue(documentType.id)
      const name = cleanValue(documentType.name)

      return {
        active: documentType.active !== false,
        required: documentType.required_by_default === true,
        createdAt: cleanValue(documentType.created_at),
        description: cleanValue(documentType.description),
        displayName,
        id,
        label: displayName || name,
        name,
        updatedAt: cleanValue(documentType.updated_at),
        value: id,
      }
    })
    .filter(({ id, label }) => Boolean(id && label))

export const toDocumentTypeBody = ({
  active = true,
  description = '',
  displayName = '',
  name = '',
  required = false,
}) => ({
  active,
  description: `${description}`.trim(),
  display_name: `${displayName}`.trim(),
  name: `${name}`.trim(),
  required_by_default: Boolean(required),
})

export const getActiveDocumentTypes = (documentTypes = []) =>
  documentTypes.filter(({ active }) => active !== false)
